function hideDispenserType() {
  $('.account_dispenser_subtype').slideUp();
}

function filterDispenserSubtype(prefix) {
  $('.account_dispenser_subtype select option').each(function(i, e) {
    var value = $(e).attr('value');
    if (value.indexOf(prefix) === 0 || value === '') {
      $(e).show().prop('disabled', false);
    } else {
      $(e).hide().prop('disabled', true);
    }
  });
  $('.account_dispenser_subtype').slideDown();
}

function dispenserTypeOnChange(el) {
  switch ($(el).val()) {
    case 'pharmacy':
      filterDispenserSubtype('ph_');
      break;
    case 'dispensing_practitioner':
      filterDispenserSubtype('dp_');
      break;
    default:
      hideDispenserType();
  }
}

$(document).ready(function() {
  dispenserTypeOnChange('#account_dispenser_type');

  $('#account_dispenser_type').change(function() {
    $('.account_dispenser_subtype select').val('');
    dispenserTypeOnChange(this);
  });
});
